<template>
  <b-container fluid class="bg-light-gray h-100 pt-4">
    <b-jumbotron class="shadow p-5 mb-5 bg-white rounded mx-auto w-75 text-center">
      <h3 class="my-2">Personal Audit Form</h3>
      <table class="w-100 spaced">
        <template v-for="field in fields" class="mb-4">
          <!-- Header -->
          <tr v-if="getHeader(field.name)" :key="getHeader(field.name)">
            <th colspan="2" class="text-site-primary font-weight-bold pt-4">
              <h5>{{ getHeader(field.name) }}</h5>
            </th>
          </tr>
          <!-- Custom Renders -->
          <tr v-if="field.name == `gender`" :key="field.name"> 
            <th class="text-right pr-4 align-top" width="40%">Gender</th>
            <td class="text-left">
              <b-form-radio-group v-model="entries[`gender`]" name="gender">
                <b-form-radio value="male" class="d-block">Male</b-form-radio>
                <b-form-radio value="female" class="d-block">Female</b-form-radio>
              </b-form-radio-group>
            </td>
          </tr>
          <tr v-else-if="field.name == `civilStatus`" :key="field.name"> 
            <th class="text-right pr-4 align-top" width="40%">Civil Status</th>
            <td class="text-left">
              <b-form-radio-group v-model="entries[`civilStatus`]" name="civilStatus" @change="civilStatusOthers = ''">
                <b-form-radio value="single" class="d-block">Single</b-form-radio>
                <b-form-radio value="married" class="d-block">Married</b-form-radio>
                <b-form-radio value="widow"  class="d-block">Widow</b-form-radio>
                <b-form-input class="w-25" v-model="civilStatusOthers" @input="entries[`civilStatus`] = civilStatusOthers" placeholder="Others" size="sm"></b-form-input>
              </b-form-radio-group>
            </td>
          </tr>
          <tr v-else-if="field.name == `islandGroup`" :key="field.name"> 
            <th class="text-right pr-4 align-top" width="40%">From what island group do you belong?</th>
            <td class="text-left">
              <b-form-radio-group v-model="entries[`islandGroup`]" name="islandGroup">
                <b-form-radio value="Luzon" class="d-block">Luzon</b-form-radio>
                <b-form-radio value="Visayas" class="d-block">Visayas</b-form-radio>
                <b-form-radio value="Mindanao" class="d-block">Mindanao</b-form-radio>
              </b-form-radio-group>
            </td>
          </tr>
          <tr v-else-if="field.name == `educationalLevel`" :key="field.name"> 
            <th class="text-right pr-4 align-top" width="40%">Educational Level</th>
            <td class="text-left">
              <b-form-radio-group v-model="entries[`educationalLevel`]" name="educationalLevel" @change="educationalLevelOthers = ''">
                <b-form-radio value="High School" class="d-block">High School</b-form-radio>
                <b-form-radio value="College" class="d-block">College</b-form-radio>
                <b-form-radio value="Masters" class="d-block">Masters</b-form-radio>
                <b-form-radio value="Doctorate" class="d-block">Doctorate</b-form-radio>
                <b-form-input class="w-25" v-model="educationalLevelOthers" @input="entries[`educationalLevel`] = educationalLevelOthers" placeholder="Others" size="sm"></b-form-input>
              </b-form-radio-group>
            </td>
          </tr>
          <!-- Standard Render -->
          <tr v-else :key="field.name">
            <th class="text-right pr-4" width="40%">{{ fieldName(field.name) }}</th>
            <td>
              <b-form-input :type="fieldType(field.type)" v-model="entries[field.name]"></b-form-input>
            </td>
          </tr>
        </template>
      </table>
      <b-form>
        <b-button class="mx-auto w-50" @click="saveInfo" variant="primary">Submit</b-button>
      </b-form>
    </b-jumbotron>
  </b-container>
</template>

<script>
export default {
  name: "ExamineePersonalInfo",
  data() {
    return {
      fields: [],
      entries: {},
      customFields: {
        islandGroup: {
          label: `From what island group do you belong?`,
          innerHtml: `
            <b-form-radio-group v-model="entries[islandGroup]" name="islandGroup">
              <b-form-radio value="Luzon">Luzon</b-form-radio>
              <b-form-radio value="Visayas">Visayas</b-form-radio>
              <b-form-radio value="Mindanao">Mindanao</b-form-radio>
            </b-form-radio-group>
            
          `,
        },
      },
      civilStatusOthers : ``,
      educationalLevelOthers : ``,
    };
  },
  mounted() {
    this.$store.dispatch("examinee/fields").then((res) => {
      if (!res.data) throw new Error();
      this.fields = res.data;
    });
  },
  methods: {
    fieldName(field) {
      var name = field;
      return name
        .replace(/([A-Z])/g, (match) => ` ${match}`)
        .replace(/^./, (match) => match.toUpperCase());
    },
    fieldType(field) {
      var type = field;
      if (type === `STRING`) return "text";
      if (type === `INTEGER`) return "number";
      if (type === `DATETIME`) return "date";
    },
    saveInfo() {
      this.$store
        .dispatch("examinee/update", {
          id: this.$store.getters["user/roleId"],
          data: { ...this.entries, status: "personalinfogiven" },
        })
        .then(() => {
          return this.$router.push(`/examinee/reminder`);
        });
    },
    getHeader(fieldName) {
      const headerMap = {
        lastName: "IDENTIFYING DATA",
        fathersName: "FAMILY DATA",
        primarySchool: "EDUCATIONAL DATA",
      };
      return headerMap[fieldName];
    },
  },
};
</script>

<style lang="css" scoped>
.spaced {
  border-collapse: separate;
  border-spacing: 0 1em;
}
.termsAndConditionContainer {
  overflow-y: scroll;
  height: 350px;
}
</style>